import { logout } from './auth'
import getMe from './me'
import getPendoInfo from './pendo'

const authApi = {
  getMe: {
    key: 'FETCH_ME_API_KEY',
    fn: getMe,
  },
  getPendoInfo: {
    key: 'FETCH_PENDO_INFO_KEY',
    fn: getPendoInfo,
  },
  logout: {
    key: 'LOGOUT_USER',
    fn: logout,
  },
}

export default authApi
